export default "__VITE_ASSET__e5827d84__"